<template>
  <a-drawer
    :width="600"
    :title="dialogTitle"
    placement="right"
    :open="isVisibles"
    @close="handleClose"
  >
    <template #extra>
      <a-button style="margin-right: 8px" :icon="h(CloseOutlined)" @click="handleClose"
        >取消</a-button
      >
      <a-button type="primary" @click="submitForm" :icon="h(CheckOutlined)"
        >保存节点</a-button
      >
    </template>
    <a-form ref="formRef" :rules="dynamicRules" :label-col="{ span: 4 }">
      <a-divider>设置节点信息</a-divider>
      <a-form-item label="节点id" v-bind="validateInfos.nodeId" name="nodeId">
        <a-input
          v-model:value="flowNodeData.nodeId"
          placeholder="请输入节点id"
          maxlength="20"
          disabled="true"
          show-count
        />
      </a-form-item>
      <a-form-item label="节点名称" v-bind="validateInfos.label" name="label">
        <a-input
          v-model:value="flowNodeData.nodeName"
          placeholder="请输入节点名称"
          maxlength="10"
          show-count
          allowClear
        />
      </a-form-item>
      <a-divider>设置审核信息</a-divider>
      <a-form-item label="审核方式" v-bind="validateInfos.auditType" name="auditType">
        <a-radio-group
          v-model:value="flowNodeData.auditType"
          @change="auditTypeChange"
          name="radioGroup"
        >
          <a-radio :value="AuditTypeEnum.appointUser">指定人员</a-radio>
          <a-radio :value="AuditTypeEnum.appointRole">指定角色</a-radio>
          <a-radio :value="AuditTypeEnum.appointDepartment">指定部门</a-radio>
          <a-radio :value="AuditTypeEnum.appointPost">指定岗位</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="审核人员"
        v-bind="validateInfos.auditKey"
        name="auditKey"
        v-if="flowNodeData.auditType === AuditTypeEnum.appointUser"
      >
        <draggable
          v-model="flowNodeData.auditKey"
          style="display: contents"
          handle=".drag-handle"
        >
          <template #item="{ element, index }">
            <div style="width: 100%; display: flex; align-items: center">
              <a-select
                :key="element"
                allowClear
                class="ReviewerSelectStyle"
                v-model:value="flowNodeData.auditKey[index]"
                placeholder="请选择审核人员"
                style="width: 80%"
                :options="
                  userData.map((s) => {
                    return {
                      value: s.userId,
                      label: s.userName,
                      disabled: flowNodeData.auditKey.includes(s.userId),
                    };
                  })
                "
              ></a-select>
              <DragOutlined
                class="drag-handle"
                title="拖动排序"
                style="cursor: move; margin-left: 5px; font-size: 20px"
              />
              <PlusOutlined
                title="添加审核人"
                style="cursor: pointer; margin-left: 5px; font-size: 20px; color: green"
                @click="addReviewerIdClick(index, flowNodeData.auditType)"
              />
              <MinusOutlined
                v-if="index !== 0"
                title="删除审核人"
                style="cursor: pointer; margin-left: 5px; font-size: 20px; color: red"
                @click="delReviewerIdClick(index, flowNodeData.auditType)"
              />
            </div>
          </template>
        </draggable>
      </a-form-item>
      <a-form-item
        label="审核角色"
        v-bind="validateInfos.auditKey"
        name="auditKey"
        v-if="flowNodeData.auditType === AuditTypeEnum.appointRole"
      >
        <draggable
          v-model="flowNodeData.auditKey"
          style="display: contents"
          handle=".drag-handle"
        >
          <template #item="{ element, index }">
            <div style="width: 100%; display: flex; align-items: center">
              <a-select
                :key="element"
                allowClear
                class="ReviewerSelectStyle"
                v-model:value="flowNodeData.auditKey[index]"
                placeholder="请选择审核角色"
                style="width: 80%"
                :options="
                  roleData.map((s) => {
                    return {
                      value: s.roleId,
                      label: s.roleName,
                      disabled: flowNodeData.auditKey.includes(s.roleId),
                    };
                  })
                "
              ></a-select>
              <DragOutlined
                class="drag-handle"
                title="拖动排序"
                style="cursor: move; margin-left: 5px; font-size: 20px"
              />
              <PlusOutlined
                title="添加审核人"
                style="cursor: pointer; margin-left: 5px; font-size: 20px; color: green"
                @click="addReviewerIdClick(index, flowNodeData.auditType)"
              />
              <MinusOutlined
                v-if="index !== 0"
                title="删除审核人"
                style="cursor: pointer; margin-left: 5px; font-size: 20px; color: red"
                @click="delReviewerIdClick(index, flowNodeData.auditType)"
              />
            </div>
          </template>
        </draggable>
      </a-form-item>
      <a-form-item
        label="审核部门"
        v-bind="validateInfos.auditKey"
        name="auditKey"
        v-if="flowNodeData.auditType === AuditTypeEnum.appointDepartment"
      >
        <draggable
          v-model="flowNodeData.auditKey"
          style="display: contents"
          handle=".drag-handle"
        >
          <template #item="{ element, index }">
            <div style="width: 100%; display: flex; align-items: center">
              <a-select
                :key="element"
                allowClear
                class="ReviewerSelectStyle"
                v-model:value="flowNodeData.auditKey[index]"
                placeholder="请选择审核部门"
                style="width: 80%"
                :options="
                  departmentData.map((s) => {
                    return {
                      value: s.departmentId,
                      label: s.departmentName,
                      disabled: flowNodeData.auditKey.includes(s.departmentId),
                    };
                  })
                "
              ></a-select>
              <DragOutlined
                class="drag-handle"
                title="拖动排序"
                style="cursor: move; margin-left: 5px; font-size: 20px"
              />
              <PlusOutlined
                title="添加审核人"
                style="cursor: pointer; margin-left: 5px; font-size: 20px; color: green"
                @click="addReviewerIdClick(index, flowNodeData.auditType)"
              />
              <MinusOutlined
                v-if="index !== 0"
                title="删除审核人"
                style="cursor: pointer; margin-left: 5px; font-size: 20px; color: red"
                @click="delReviewerIdClick(index, flowNodeData.auditType)"
              />
            </div>
          </template>
        </draggable>
      </a-form-item>
      <a-form-item
        label="审核岗位"
        v-bind="validateInfos.auditKey"
        name="auditKey"
        v-if="flowNodeData.auditType === AuditTypeEnum.appointPost"
      >
        <draggable
          v-model="flowNodeData.auditKey"
          style="display: contents"
          handle=".drag-handle"
        >
          <template #item="{ element, index }">
            <div style="width: 100%; display: flex; align-items: center">
              <a-select
                :key="element"
                allowClear
                class="ReviewerSelectStyle"
                v-model:value="flowNodeData.auditKey[index]"
                placeholder="请选择审核岗位"
                style="width: 80%"
                :options="
                  postData.map((s) => {
                    return {
                      value: s.postId,
                      label: s.postName,
                      disabled: flowNodeData.auditKey.includes(s.postId),
                    };
                  })
                "
              ></a-select>
              <DragOutlined
                class="drag-handle"
                title="拖动排序"
                style="cursor: move; margin-left: 5px; font-size: 20px"
              />
              <PlusOutlined
                title="添加审核人"
                style="cursor: pointer; margin-left: 5px; font-size: 20px; color: green"
                @click="addReviewerIdClick(index, flowNodeData.auditType)"
              />
              <MinusOutlined
                v-if="index !== 0"
                title="删除审核人"
                style="cursor: pointer; margin-left: 5px; font-size: 20px; color: red"
                @click="delReviewerIdClick(index, flowNodeData.auditType)"
              />
            </div>
          </template>
        </draggable>
      </a-form-item>
      <a-form-item label="抄送给">
        <a-select
          allowClear
          mode="multiple"
          v-model:value="flowNodeData.carbonCopyUser"
          style="width: 80%"
          :options="
            userData.map((s) => {
              return { value: s.userId, label: s.userName };
            })
          "
        ></a-select>
        <a-tooltip placement="bottom" color="#f50">
          <template #title>
            <span>当前节点审核通过后，流程会自动发送给抄送人</span>
          </template>
          <QuestionCircleOutlined
            style="font-size: 20px; margin-left: 5px; color: #f50"
          />
        </a-tooltip>
      </a-form-item>
      <div
        style="
          text-align: left;
          display: flex;
          align-items: center;
          font-size: 12px;
          margin-bottom: 20px;
          padding-left: 14px;
        "
      >
        <QuestionCircleOutlined
          style="font-size: 16px; margin-left: 5px; color: #f50"
        />拖动审核人员（角色、部门、职位）可以改变审核顺序
      </div>
      <a-divider>会签方式</a-divider>
      <a-form-item label="会签方式">
        <a-radio-group v-model:value="flowNodeData.countersignWay" name="radioGroup4">
          <a-radio :value="NodeCountersignWayEnum.AllReviewerExamine"
            >所有人审批（且签）</a-radio
          >
          <a-radio :value="NodeCountersignWayEnum.EitherReviewerExamine"
            >任意一人审批（或签）</a-radio
          >
        </a-radio-group>
        <a-tooltip placement="bottom" color="#f50" style="width: max-content">
          <template #title>
            <div>
              且签：当前选择的审核（人员、角色、部门、职位）都必须审批<br />
              或签：指定的审核方式，任意一人（角色、部门、职位）审批即可
            </div>
          </template>
          <QuestionCircleOutlined
            style="font-size: 20px; margin-left: 5px; color: #f50"
          />
        </a-tooltip>
      </a-form-item>
      <a-form-item
        label="会签顺序"
        v-if="flowNodeData.countersignWay === NodeCountersignWayEnum.AllReviewerExamine"
      >
        <a-radio-group v-model:value="flowNodeData.countersignOrder" name="radioGroup5">
          <a-radio :value="NodeCountersignOrderEnum.OrderAsc">按顺序会签</a-radio>
          <a-radio :value="NodeCountersignOrderEnum.NoOrder">无序会签</a-radio>
        </a-radio-group>
        <a-tooltip placement="bottom" color="#f50" style="width: max-content">
          <template #title>
            <div>
              按顺序会签：审核人按照添加顺序依次审批<br />
              无序会签：审核人无顺序，谁审批都可以
            </div>
          </template>
          <QuestionCircleOutlined
            style="font-size: 20px; margin-left: 5px; color: #f50"
          />
        </a-tooltip>
      </a-form-item>
      <a-divider>设置审核期限</a-divider>
      <a-form-item label="审核期限">
        <a-radio-group v-model:value="flowNodeData.isSetExamineExpire" name="radioGroup1">
          <a-radio :value="true">设置审核期限</a-radio>
          <a-radio :value="false">任意时间审核</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="超时日期" v-if="flowNodeData.isSetExamineExpire">
        <div style="align-items: center; display: flex">
          从
          <a-input-number
            v-model:value="flowNodeData.expireDate"
            :min="1"
            :max="100"
            style="width: 120px"
          />
          <a-select v-model:value="flowNodeData.expireType" style="width: 120px">
            <a-select-option :value="1">天</a-select-option>
            <a-select-option :value="2">小时</a-select-option>
          </a-select>
          后，未审批自动执行超时动作
        </div>
      </a-form-item>
      <a-form-item label="超时动作" v-if="flowNodeData.isSetExamineExpire">
        <a-radio-group v-model:value="flowNodeData.expireAction" name="radioGroup2">
          <a-radio :value="ExpireActionEnum.NoAction">等待审批</a-radio>
          <a-radio :value="ExpireActionEnum.Approve">自动批准</a-radio>
          <a-radio :value="ExpireActionEnum.AuditRefuse">自动拒绝</a-radio>
          <a-radio :value="ExpireActionEnum.RejectNode">驳回到上个节点</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="过期提醒" v-if="flowNodeData.isSetExamineExpire">
        <a-radio-group v-model:value="flowNodeData.isExpireRemind" name="radioGroup3">
          <a-radio :value="true">提醒</a-radio>
          <a-radio :value="false">不提醒</a-radio>
        </a-radio-group>
      </a-form-item>

      <a-form-item
        label="提前"
        v-if="flowNodeData.isExpireRemind && flowNodeData.isSetExamineExpire"
      >
        <div style="align-items: center; display: flex">
          <a-input-number
            v-model:value="flowNodeData.soonExpireDate"
            :min="10"
            :max="60"
            style="width: 50%"
          />
          <span>分钟提醒审核人</span>
        </div>
      </a-form-item>
      <a-form-item
        label="提示信息"
        v-bind="validateInfos.remindContent"
        name="remindContent"
        v-if="flowNodeData.isExpireRemind && flowNodeData.isSetExamineExpire"
      >
        <a-input
          v-model:value="flowNodeData.remindContent"
          placeholder="请输入提示信息，即将超时会把该内容发送给审核人"
          maxlength="20"
          show-count
          allowClear
        />
      </a-form-item>
    </a-form>
  </a-drawer>
</template>
<script lang="ts" setup>
import { PropType, ref, watch, h, computed } from "vue";
import { cloneDeep } from "lodash";
import { countersignNodeModel } from "../../typescript/nodeModel";
import {
  AuditTypeEnum,
  ExpireActionEnum,
  ExpireTypeEnum,
  FlowNodeStateEnum,
  NodeCountersignOrderEnum,
  NodeCountersignWayEnum,
  NodeTypeEnum,
} from "../../typescript/nodeEnum";
import { Form, message } from "ant-design-vue";
import { userData, roleData, departmentData, postData } from "../../typescript/mockData";
import {
  CheckOutlined,
  CloseOutlined,
  DragOutlined,
  PlusOutlined,
  MinusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons-vue";
import draggable from "vuedraggable";
// 组件属性定义
const props = defineProps({
  isVisibles: Boolean,
  dialogTitle: String,
  nodeModel: { type: Object as PropType<any>, required: true },
});

// 声明 emit
const emit = defineEmits(["closeBnt", "saveNodeClick"]);

//流程节点模型
const flowNodeData = ref<countersignNodeModel>({
  nodeId: "",
  nodeType: NodeTypeEnum.OrdinaryNode,
  auditType: AuditTypeEnum.appointUser,
  isSetExamineExpire: false,
  expireDate: 1,
  expireAction: ExpireActionEnum.NoAction,
  isExpireRemind: false,
  soonExpireDate: 10,
  remindContent: "",
  expireType: ExpireTypeEnum.day,
  carbonCopyUser: [],
  countersignWay: NodeCountersignWayEnum.AllReviewerExamine,
  countersignOrder: NodeCountersignOrderEnum.OrderAsc,
  nodeName: "",
  auditKey: [],
  auditState: FlowNodeStateEnum.UnPublish,
});

watch(
  () => props.isVisibles,
  () => {
    resetFields();
    if (props.isVisibles) {
      const nodeData = cloneDeep(props.nodeModel);
      flowNodeData.value.nodeId = nodeData.nodeId;
      flowNodeData.value.nodeName = nodeData.nodeName;
      flowNodeData.value.auditType =
        nodeData.auditType === 0 ? AuditTypeEnum.appointUser : nodeData.auditType;
      flowNodeData.value.auditKey =
        nodeData.auditKey.length === 0 ? [""] : nodeData.auditKey;
      flowNodeData.value.auditState = nodeData.auditState ?? FlowNodeStateEnum.UnPublish;
      flowNodeData.value.countersignWay =
        nodeData.countersignWay ?? NodeCountersignWayEnum.AllReviewerExamine;
      flowNodeData.value.countersignOrder =
        nodeData.countersignOrder ?? NodeCountersignOrderEnum.OrderAsc;
      flowNodeData.value.carbonCopyUser = nodeData.carbonCopyUser ?? [];
      flowNodeData.value.isSetExamineExpire = nodeData.isSetExamineExpire ?? false;
      flowNodeData.value.expireDate = nodeData.expireDate ?? 1;
      flowNodeData.value.expireAction =
        nodeData.expireAction ?? ExpireActionEnum.NoAction;
      flowNodeData.value.isExpireRemind = nodeData.isExpireRemind ?? false;
      flowNodeData.value.soonExpireDate = nodeData.soonExpireDate ?? 10;
      flowNodeData.value.remindContent = nodeData.remindContent ?? "";
      flowNodeData.value.nodeType = nodeData.nodeType ?? NodeTypeEnum.OrdinaryNode;
      flowNodeData.value.expireType =
        nodeData.expireType === 0 || nodeData.expireType === undefined
          ? 1
          : nodeData.expireType;
    }
  }
);

// 动态验证规则
const dynamicRules = computed(() => {
  const rules: any = {
    label: [{ required: true, message: "请输入节点名称" }],
    auditType: [{ required: true, message: "请选择审核方式" }],
  };

  // 根据当前审核方式动态设置验证规则
  switch (flowNodeData.value.auditType) {
    case AuditTypeEnum.appointUser:
      rules.auditKey = [{ required: true, message: "请选择审核人员" }];
      break;
    case AuditTypeEnum.appointRole:
      rules.auditKey = [{ required: true, message: "请选择审核角色" }];
      break;
    case AuditTypeEnum.appointDepartment:
      rules.auditKey = [{ required: true, message: "请选择审核部门" }];
      break;
    case AuditTypeEnum.appointPost:
      rules.auditKey = [{ required: true, message: "请选择审核岗位" }];
      break;
  }

  // 审核期限相关验证
  if (flowNodeData.value.isSetExamineExpire) {
    rules.expireDate = [{ required: true, message: "请输入超时日期" }];
    rules.expireAction = [{ required: true, message: "请选择超时动作" }];

    if (flowNodeData.value.isExpireRemind) {
      rules.soonExpireDate = [{ required: true, message: "请输入提前提醒时间" }];
      rules.remindContent = [{ required: true, message: "请输入提示信息" }];
    } else {
      rules.soonExpireDate = [];
      rules.remindContent = [];
    }
  } else {
    // 不设置审核期限时，清空相关验证
    rules.expireDate = [];
    rules.expireAction = [];
    rules.isExpireRemind = [];
    rules.soonExpireDate = [];
    rules.remindContent = [];
  }

  return rules;
});

const { resetFields, validate, validateInfos } = Form.useForm(
  flowNodeData.value,
  dynamicRules
);

//审核方式改变
const auditTypeChange = function () {
  flowNodeData.value.auditKey = [""];
};

//添加审核人事件
const addReviewerIdClick = function (index: number, type: AuditTypeEnum) {
  if (type === AuditTypeEnum.appointUser) {
    if (flowNodeData.value.auditKey.length > 10) {
      message.warning("会签节点最多添加10个审核人");
      return;
    } else flowNodeData.value.auditKey.splice(index + 1, 0, "");
  }
  if (type === AuditTypeEnum.appointRole) {
    if (flowNodeData.value.auditKey.length > 10) {
      message.warning("会签节点最多添加10个审核角色");
      return;
    } else flowNodeData.value.auditKey.splice(index + 1, 0, "");
  }
  if (type === AuditTypeEnum.appointDepartment) {
    if (flowNodeData.value.auditKey.length > 10) {
      message.warning("会签节点最多添加10个审核部门");
      return;
    } else flowNodeData.value.auditKey.splice(index + 1, 0, "");
  }
  if (type === AuditTypeEnum.appointPost) {
    if (flowNodeData.value.auditKey.length > 10) {
      message.warning("会签节点最多添加10个审核岗位");
      return;
    } else flowNodeData.value.auditKey.splice(index + 1, 0, "");
  }
};

//删除审核人事件
const delReviewerIdClick = function (index: number, type: AuditTypeEnum) {
  if (type === AuditTypeEnum.appointUser) {
    flowNodeData.value.auditKey.splice(index, 1);
  }
  if (type === AuditTypeEnum.appointRole) {
    flowNodeData.value.auditKey.splice(index, 1);
  }
  if (type === AuditTypeEnum.appointDepartment) {
    flowNodeData.value.auditKey.splice(index, 1);
  }
  if (type === AuditTypeEnum.appointPost) {
    flowNodeData.value.auditKey.splice(index, 1);
  }
};

const submitForm = () => {
  validate()
    .then(() => {
      if (
        flowNodeData.value.auditKey.some((f) => f === "" || f === undefined) &&
        flowNodeData.value.auditType === AuditTypeEnum.appointUser
      ) {
        message.warning("审核人不能为空");
        return;
      }
      if (
        flowNodeData.value.auditKey.some((f) => f === "" || f === undefined) &&
        flowNodeData.value.auditType === AuditTypeEnum.appointDepartment
      ) {
        message.warning("审核部门不能为空");
        return;
      }
      if (
        flowNodeData.value.auditKey.some((f) => f === "" || f === undefined) &&
        flowNodeData.value.auditType === AuditTypeEnum.appointPost
      ) {
        message.warning("审核岗位不能为空");
        return;
      }
      if (
        flowNodeData.value.auditKey.some((f) => f === "" || f === undefined) &&
        flowNodeData.value.auditType === AuditTypeEnum.appointRole
      ) {
        message.warning("审核角色不能为空");
        return;
      }
      if (
        flowNodeData.value.carbonCopyUser !== undefined &&
        flowNodeData.value.carbonCopyUser.some(
          (f) =>
            flowNodeData.value.auditKey.includes(f) &&
            flowNodeData.value.auditType === AuditTypeEnum.appointUser
        )
      ) {
        message.warning("审核人和抄送人不能是同一个人");
        return;
      }
      if (
        flowNodeData.value.isExpireRemind &&
        (flowNodeData.value.remindContent == "" ||
          flowNodeData.value.remindContent === undefined)
      ) {
        message.warning("请输入过期提醒内容");
        return;
      }
      emit("saveNodeClick", cloneDeep(flowNodeData.value));
      emit("closeBnt");
    })
    .catch(() => {
      // message.error(ers[0].message);
    });
};

//关闭事件
const handleClose = () => {
  emit("closeBnt");
  // resetForm(ruleFormRef.value);
};
</script>

<style>
.ReviewerSelectStyle {
  margin-bottom: 5px;
}
</style>
